// 🔴🔴 N°889 — LE 422 DOIT SE LIRE, ⛔ PAS FAIRE DISPARAÎTRE L'ÉCRAN.
// ⚠️ MESURÉ en PROD le 29/09 à 08:35 (nginx, IP de JJ) : UN POST
// /api/metier/catalogue/produits → **422**, 209 octets, ⛔ aucune écriture. Le
// corps d'un 422 FastAPI est `detail: [ {loc, msg, type}, … ]` — un **TABLEAU
// D'OBJETS**. Les trois appels `toast.error(err.detail)` de cet écran le
// passaient TEL QUEL à un composant de rendu : au mieux « [object Object] », au
// pire un crash React (« Objects are not valid as a React child ») ⇒ page
// blanche. Dans les deux cas l'utilisateur ⛔ n'apprend JAMAIS quel champ est
// refusé.
// 🔑 UNE fonction, ⛔ pas trois formatages recopiés : les trois sites (import,
// produit, service) portaient la MÊME faute.
export function messageErreurValidation(detail, repli) {
  if (!detail) return repli;
  if (typeof detail === "string") return detail;
  if (!Array.isArray(detail)) return repli;
  const champs = detail.map((e) => {
    // `loc` vaut ["body", "<champ>"] : on NOMME le champ, c'est tout l'intérêt.
    const loc = Array.isArray(e?.loc) ? e.loc.filter((x) => x !== "body") : [];
    const nom = loc.length ? loc.join(".") : null;
    const msg = typeof e?.msg === "string" ? e.msg : "valeur refusée";
    return nom ? `${nom} : ${msg}` : msg;
  });
  return champs.length ? champs.join(" · ") : repli;
}

// ⛔ Les deux champs que le backend exige (`min_length: 1`) et que le formulaire
// initialisait à "" puis envoyait TELS QUELS — c'est l'origine du 422 de JJ.
// 🔑 On REFUSE l'envoi en NOMMANT le champ. ⛔ On ⛔ n'INVENTE PAS de référence :
// une référence fabriquée par l'écran entrerait au catalogue sans que personne
// ⛔ ne l'ait décidée.
export function champsObligatoiresManquants(data) {
  const manques = [];
  // 🔴 N°890 — DÉCISION JJ : la RÉFÉRENCE ⛔ NE BLOQUE PLUS. Absente, elle est
  // ATTRIBUÉE par le moteur de séquences du tenant (MAX+1), ⛔ pas inventée par
  // l'écran. Seule la DÉSIGNATION reste exigée : c'est le seul champ que
  // personne ⛔ ne peut deviner à la place de l'artisan.
  if (!String(data?.designation || "").trim()) manques.push("Désignation");
  return manques;
}

// ⛔ Une référence VIDE ⛔ ne doit PAS partir comme `""` : le backend l'accepte
// ABSENTE et la génère. Envoyer `""` était exactement ce qui déclenchait le 422.
export function refSaisieOuOmise(reference) {
  const v = String(reference || "").trim();
  return v ? { reference: v } : {};
}
